module.exports = __webpack_public_path__ + "img/15.85b29dfc.jpg";